module.exports = __webpack_public_path__ + "static/media/mapTaxiMore.2e7ae7c7.png";